import React, { Fragment, useEffect, useState } from 'react';
import './box.css'
import { connect } from 'react-redux';
import { toggleDm, boxDmInput, computeDm } from '../../redux/actions/shipping/shipping.action';

const BoxDm = ({shipping : {selected_po}, index, toggleDm, boxDmInput, computeDm}) => {
    
    return (
        <div className='box-pop'>
            <div className='box-header'>
                <a onClick={() => toggleDm(index)}><i className='ft ft-x'></i></a>
            </div>
            <div className='row mb-1'>
                <label className='col-3'>Length</label>
                <div className='col-2'></div>
                <div className='col-7'>
                    <div className="input-group">
                        <input type="number" className='form-control text-right' name="length" placeholder='0' onChange={(e) => boxDmInput(e, index)} value={selected_po.purchase_order_items[index].box_dm.length}/>
                        <div className="input-group-append">
                            <span className="input-group-text">m</span>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div className='row mb-1'>
                <label className='col-3'>Width</label>
                <div className='col-2'></div>
                <div className='col-7'>
                    <div className="input-group">
                        <input type="number" className='form-control text-right' name="width" placeholder='0' onChange={(e) => boxDmInput(e, index)} value={selected_po.purchase_order_items[index].box_dm.width}/>
                        <div className="input-group-append">
                            <span className="input-group-text">m</span>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div className='row mb-1'>
                <label className='col-3'>Height</label>
                <div className='col-2'></div>
                <div className='col-7'>
                    <div className="input-group">
                        <input type="number" className='form-control text-right' name="height" placeholder='0' onChange={(e) => boxDmInput(e, index)} value={selected_po.purchase_order_items[index].box_dm.height}/>
                        <div className="input-group-append">
                            <span className="input-group-text">m</span>
                        </div>
                    </div>
                    
                </div>
            </div>
            
            <div className='row mb-1'>
                <div className='col-12 text-right'>
                    <button className='btn btn-primary' onClick={() => computeDm(index)}>Ok</button>
                </div>
            </div>
        </div>
        
    )
}


const mapStateToProps = state => ({
    shipping : state.shipping
})

export default connect(mapStateToProps, {toggleDm, boxDmInput, computeDm})(BoxDm);